









































































import { Component, Vue } from 'vue-property-decorator';
import BaseVue from '@/core/BaseVue';
import GenericEdit from '@/core/Generics/GenericEdit';
import Area from "@/models/coding/areaModel";
import IndicatorGroup from '@/models/indicator/indicatorGroup.model';
@Component
export default class IndicatorGroupEdit extends GenericEdit<IndicatorGroup> {
  constructor() {
    super();
    this.controller = 'IndicatorGroups';
    this.model = new IndicatorGroup();
  }
    public validarCodigo(event: any) {
    if(event.keyCode === 32) {
      event.preventDefault();
    }
  }
}
